import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdTipoRiesgo } from "@/shared/actions";
import SaveTipoRiesgo from "../../components/save-tipo-riesgo/SaveTipoRiesgo";

export default function UpdateTipoRiesgoPage() {
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchGetByIdTipoRiesgo(id!);
  if (isLoading || isRefetching) return <LoaderComponent />;
  return <SaveTipoRiesgo titulo="Actualizar tipo de riesgo" data={data?.data} />;
}
